export type StoredComment = {
  id: string;
  name: string;
  body: string;
  createdAt: string;
};

type CommentListProps = {
  comments: StoredComment[];
};

export function CommentList({ comments }: CommentListProps) {
  if (comments.length === 0) {
    return <p className="empty-state">No comments yet. Start the discussion with a useful note.</p>;
  }

  return (
    <ol className="comment-list">
      {comments.map((comment) => (
        <li key={comment.id}>
          <article>
            <header>
              <strong>{comment.name}</strong>
              <time dateTime={comment.createdAt}>
                {new Intl.DateTimeFormat("en", { dateStyle: "medium", timeStyle: "short" }).format(
                  new Date(comment.createdAt)
                )}
              </time>
            </header>
            <p>{comment.body}</p>
          </article>
        </li>
      ))}
    </ol>
  );
}
